import angular from 'angular'

import template from './vd-dott.html'

class DottController {
  constructor($location) {
    this._$location = $location
    this._useAbsoluteUrl = false
  }

  $onInit() {
    this._useAbsoluteUrl =
      this.useAbsoluteUrl !== undefined ? this.useAbsoluteUrl : true
  }

  /**
   * Prepends the requested definition id with the current absolute url. Without this, the SVG is rendered black in
   * Safari when apps have a base tag set.
   *
   * @param {String} id
   *
   * @return {String}
   */
  getUrl(id) {
    return this._useAbsoluteUrl
      ? `url(${this._$location.absUrl()}#${id})`
      : `url(#${id})`
  }
}

const DottComponent = {
  bindings: {
    useAbsoluteUrl: '<?',
  },
  template,
  controller: DottController,
}

angular.module('vend.ui').component('vdDott', DottComponent)
